import { format } from '@/utils/date-fns/format'

/**
 * The `manual_split` action field a work-period split writes on both halves.
 * `side` says which half this log sits on: `before` is the day that keeps the
 * hours up to the boundary, `after` the one that was split off at it.
 */
export interface ManualSplitTranslations {
  splitBefore: (values: { boundary: string; workPeriod: string }) => string
  splitAfter: (values: { boundary: string; workPeriod: string }) => string
}

export function formatManualSplit(
  raw: unknown,
  translations: ManualSplitTranslations
): string {
  if (!raw || typeof raw !== 'object') return '-'

  const value = raw as {
    boundary?: unknown
    side?: unknown
    other_work_period_id?: unknown
  }

  if (typeof value.boundary !== 'string') return '-'
  const boundaryDate = new Date(value.boundary)
  if (Number.isNaN(boundaryDate.getTime())) return '-'

  const values = {
    boundary: format(boundaryDate, 'dd.MM.yyyy HH:mm'),
    workPeriod:
      value.other_work_period_id == null
        ? '-'
        : String(value.other_work_period_id),
  }

  return value.side === 'after'
    ? translations.splitAfter(values)
    : translations.splitBefore(values)
}
